// src/components/ModalNovoProduto.jsx
import React, { useState, useEffect } from "react";
import {
  FaTag, FaBarcode, FaCubes, FaDollarSign, FaPercent, FaBalanceScale,
  FaStickyNote, FaExchangeAlt, FaFileInvoiceDollar, FaListOl, FaGavel,
  FaChevronDown, FaChevronUp, FaPlusCircle, FaSave
} from "react-icons/fa";
import { IMaskInput } from "react-imask";
import {
  getFirestore, collection, addDoc, query, where, getDocs, updateDoc, doc, getDoc, Timestamp
} from "firebase/firestore";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// --- 1. IMPORT NOVO AQUI ---
import { useEmpresaId } from "../context/EmpresaContext"; 

// Conversão 1.234,56 -> 1234.56
function parseFloatBR(val) {
  if (typeof val === "number") return val;
  if (!val) return 0;
  return parseFloat(String(val).replace(/\./g, '').replace(',', '.')) || 0;
}

// Normalização para busca
const normalizeText = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const InputIcon = ({ icon, ...props }) => (
  <div className="relative">
    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-400">{icon}</span>
    {props.mask ? (
      <IMaskInput 
        {...props} 
        value={props.value || ""} 
        className={`pl-10 ${props.className || ""}`} 
      />
    ) : (
      <input 
        {...props} 
        value={props.value || ""} 
        className={`pl-10 ${props.className || ""}`} 
      />
    )}
  </div>
);

const unidades = ["UN", "KG", "LT", "MT"];
const defaultForm = {
  sku: "", nome: "", descricao: "", ncm: "", precoBruto: "", porcentagemLucro: "",
  estoque: "", unidade: "UN", cfop: "5102", csosn: "", cst: "", icms_origem: "",
  cest: "", pis_situacao_tributaria: "", cofins_situacao_tributaria: "", ipi_situacao_tributaria: "",
};

// ... (Mantenha as constantes de OPTIONS aqui: CSOSN_OPTIONS, CST_OPTIONS, etc. - Elas não mudaram) ...
// Para economizar espaço visual aqui, vou assumir que você manteve as constantes do código anterior.
// Se precisar delas novamente, me avise!

const CSOSN_OPTIONS = [
    { value: "101", label: "101 - Tributada pelo Simples com crédito" },
    { value: "102", label: "102 - Tributada pelo Simples sem crédito" },
    { value: "103", label: "103 - Isenção do ICMS no Simples" },
    { value: "201", label: "201 - Tributada Simples, c/ crédito e ST" },
    { value: "202", label: "202 - Tributada Simples, s/ crédito, com ST" },
    { value: "203", label: "203 - Isenção do Simples, com ST" },
    { value: "300", label: "300 - Imune" },
    { value: "400", label: "400 - Não tributada pelo Simples" },
    { value: "500", label: "500 - ICMS cobrado anteriormente (Substituição Tributária)" },
    { value: "900", label: "900 - Outros" }
  ];
  const CST_OPTIONS = [
    { value: "00", label: "00 - Tributado integralmente" },
    { value: "10", label: "10 - Tributado c/ cobrança de ST" },
    { value: "20", label: "20 - Com redução da base de cálculo" },
    { value: "30", label: "30 - Isenta/Não tributada c/ cobrança de ST" },
    { value: "40", label: "40 - Isenta" },
    { value: "41", label: "41 - Não tributada" },
    { value: "50", label: "50 - Suspensão" },
    { value: "51", label: "51 - Diferimento" },
    { value: "60", label: "60 - ICMS cobrado anteriormente (Substituição Tributária)" },
    { value: "70", label: "70 - Com redução e cobrança de ST" },
    { value: "90", label: "90 - Outros" }
  ];
  const ICMS_ORIGEM_OPTIONS = [
    { value: "0", label: "0 - Nacional" },
    { value: "1", label: "1 - Estrangeira - Importação direta" },
    { value: "2", label: "2 - Estrangeira - Adquirida no mercado interno" },
    { value: "3", label: "3 - Nacional, conteúdo importado > 40%" },
    { value: "4", label: "4 - Nacional, conteúdo importado <= 40%" },
    { value: "5", label: "5 - Nacional, conteúdo importado indefinido" },
    { value: "6", label: "6 - Estrangeira, importação direta, sem similar nacional" },
    { value: "7", label: "7 - Estrangeira, adquirida mercado interno, sem similar nacional" },
    { value: "8", label: "8 - Nacional, conforme resolução" }
  ];
  const SITUACAO_TRIBUTARIA_OPTIONS = [
    { value: "01", label: "01 - Operação Tributável" },
    { value: "04", label: "04 - Tributável Monofásica" },
    { value: "06", label: "06 - Tributável alíquota zero" },
    { value: "07", label: "07 - Isenta" },
    { value: "08", label: "08 - Sem incidência" },
    { value: "09", label: "09 - Suspensão" }
  ];

const CSOSN_VALIDOS = ["101","102","103","201","202","203","300","400","500","900"];
const CST_VALIDOS   = ["00","10","20","30","40","41","50","51","60","70","90"];

// validação
const validarProdutoFiscalOnModal = (form, regimeTributario) => {
  const e = {};
  if (!form.sku) e.sku = "Campo obrigatório";
  if (!form.nome) e.nome = "Campo obrigatório";
  if (!form.precoBruto || isNaN(parseFloatBR(form.precoBruto))) e.precoBruto = "Campo obrigatório";
  if (!form.estoque || isNaN(Number(form.estoque))) e.estoque = "Campo obrigatório";
  if (!form.ncm) e.ncm = "Campo obrigatório";
  if (!form.cfop) e.cfop = "Campo obrigatório";
  if (regimeTributario === "1" || regimeTributario === "4") {
    if (!form.csosn) e.csosn = "Obrigatório p/ Simples Nacional";
    else if (!CSOSN_VALIDOS.includes(form.csosn)) e.csosn = "CSOSN inválido p/ regime Simples Nacional";
  } else {
    if (!form.cst) e.cst = "Obrigatório p/ regime Normal";
    else if (!CST_VALIDOS.includes(form.cst)) e.cst = "CST inválido p/ regime Normal";
  }
  if (!form.icms_origem) e.icms_origem = "Origem obrigatória";
  if (!form.pis_situacao_tributaria) e.pis_situacao_tributaria = "Campo obrigatório";
  if (!form.cofins_situacao_tributaria) e.cofins_situacao_tributaria = "Campo obrigatório";
  if (!form.ipi_situacao_tributaria) e.ipi_situacao_tributaria = "Campo obrigatório";
  return e;
};

// helpers de caminho
const colProdutos = (db, empresaId) => collection(db, 'empresas', empresaId, 'produtos');
const refProduto  = (db, empresaId, id) => doc(db, 'empresas', empresaId, 'produtos', id);

const ModalNovoProduto = ({
  open,
  onClose,
  onImportar,
  empresaId: propEmpresaId,
  produtoEdicao
}) => {
  const db = getFirestore();
  
  // --- 2. CORREÇÃO AQUI: Pegar ID do Contexto também ---
  const contextEmpresaId = useEmpresaId(); 
  const empresaId = propEmpresaId || contextEmpresaId || localStorage.getItem("empresaId");
  // -----------------------------------------------------

  const [form, setForm] = useState(defaultForm);
  const [precoVenda, setPrecoVenda] = useState("");
  const [errors, setErrors] = useState({});
  const [editando, setEditando] = useState(false);
  const [produtoId, setProdutoId] = useState(null);
  const [regimeTributario, setRegimeTributario] = useState("");
  const [detalhesFiscais, setDetalhesFiscais] = useState(false);

  // regime tributário da empresa
  useEffect(() => {
    if (!open || !empresaId) return;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "empresas", empresaId));
        setRegimeTributario(snap.exists() ? (snap.data().regimeTributario || "1") : "1");
      } catch {
        setRegimeTributario("1");
      }
    })();
  }, [empresaId, open, db]);

  // carregar dados quando abre
  useEffect(() => {
    if (!open) return;

    if (produtoEdicao) {
      const novoForm = {
        sku: produtoEdicao.sku || "",
        nome: produtoEdicao.nome || "",
        descricao: produtoEdicao.descricao || "",
        ncm: produtoEdicao.ncm || "",
        precoBruto: produtoEdicao.precoBruto !== undefined ? String(produtoEdicao.precoBruto).replace(".", ",") : "",
        porcentagemLucro: produtoEdicao.porcentagemLucro !== undefined ? String(produtoEdicao.porcentagemLucro).replace(".", ",") : "",
        estoque: produtoEdicao.estoque !== undefined ? String(produtoEdicao.estoque) : "",
        unidade: produtoEdicao.unidade || "UN",
        cfop: produtoEdicao.cfop || "5102",
        csosn: produtoEdicao.csosn || "",
        cst: produtoEdicao.cst || "",
        icms_origem: produtoEdicao.icms_origem || "",
        cest: produtoEdicao.cest || "",
        pis_situacao_tributaria: produtoEdicao.pis_situacao_tributaria || "",
        cofins_situacao_tributaria: produtoEdicao.cofins_situacao_tributaria || "",
        ipi_situacao_tributaria: produtoEdicao.ipi_situacao_tributaria || "",
      };
      setForm(novoForm);
      setEditando(true);
      setProdutoId(produtoEdicao.id);

      setTimeout(() => {
        const e = validarProdutoFiscalOnModal(novoForm, regimeTributario);
        setErrors(e);
        if (e.csosn || e.cst || e.icms_origem || e.pis_situacao_tributaria || e.cofins_situacao_tributaria || e.ipi_situacao_tributaria) {
          setDetalhesFiscais(true);
        }
      }, 0);
    } else {
      setForm(defaultForm);
      setEditando(false);
      setProdutoId(null);
      setErrors({});
      setDetalhesFiscais(false);
    }
  }, [open, produtoEdicao, regimeTributario]);

  // calcula preço de venda exibido
  useEffect(() => {
    const preco = parseFloatBR(form.precoBruto);
    const lucro = parseFloatBR(form.porcentagemLucro);
    if (!isNaN(preco) && !isNaN(lucro)) {
      setPrecoVenda(
        (preco * (1 + lucro / 100)).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    } else {
      setPrecoVenda("");
    }
  }, [form.precoBruto, form.porcentagemLucro]);

  // buscar SKU existente
  const handleBuscaSku = async () => {
    if (!form.sku || !empresaId || editando) return;
    try {
      const qSku = query(colProdutos(db, empresaId), where("sku", "==", form.sku));
      const snapshot = await getDocs(qSku);
      if (!snapshot.empty) {
        const prod = snapshot.docs[0].data();
        setForm({
          sku: prod.sku || "",
          nome: prod.nome || "",
          descricao: prod.descricao || "",
          ncm: prod.ncm || "",
          precoBruto: prod.precoBruto !== undefined ? String(prod.precoBruto).replace(".", ",") : "",
          porcentagemLucro: prod.porcentagemLucro !== undefined ? String(prod.porcentagemLucro).replace(".", ",") : "",
          estoque: prod.estoque !== undefined ? String(prod.estoque) : "",
          unidade: prod.unidade || "UN",
          cfop: prod.cfop || "5102",
          csosn: prod.csosn || "",
          cst: prod.cst || "",
          icms_origem: prod.icms_origem || "",
          cest: prod.cest || "",
          pis_situacao_tributaria: prod.pis_situacao_tributaria || "",
          cofins_situacao_tributaria: prod.cofins_situacao_tributaria || "",
          ipi_situacao_tributaria: prod.ipi_situacao_tributaria || "",
        });
        setProdutoId(snapshot.docs[0].id);
        setEditando(true);
      } else {
        setEditando(false);
        setProdutoId(null);
      }
    } catch {
      setErrors(e => ({ ...e, sku: "Erro ao buscar SKU" }));
    }
  };

  const onChange = (key, value) => {
    setForm(f => ({ ...f, [key]: value }));
    setErrors(e => ({ ...e, [key]: null }));
  };

  const validar = () => validarProdutoFiscalOnModal(form, regimeTributario);

  const handleSave = async () => {
    // 3. Verificação de Segurança (Agora com ID do contexto)
    if (!empresaId) {
        Swal.fire({ icon: "error", title: "Erro de Empresa", text: "ID da empresa não encontrado. Tente fazer Logout e Login novamente." });
        return;
    }

    const e = validar();
    setErrors(e);
    if (Object.keys(e).length) {
      if (!detalhesFiscais) setDetalhesFiscais(true);
      return;
    }

    const precoBruto = parseFloatBR(form.precoBruto);
    const porcentagemLucro = parseFloatBR(form.porcentagemLucro);
    const estoque = parseFloatBR(form.estoque);
    const precoVendaCalc = !isNaN(precoBruto) && !isNaN(porcentagemLucro)
      ? Number(precoBruto * (1 + porcentagemLucro / 100))
      : 0;

    const dados = {
      ...form,
      sku: form.sku || "",
      nome: form.nome || "",
      precoBruto,
      porcentagemLucro,
      estoque,
      precoVenda: precoVendaCalc,
      csosn: (regimeTributario === "1" || regimeTributario === "4") ? (form.csosn || "") : "",
      cst: (regimeTributario !== "1" && regimeTributario !== "4") ? (form.cst || "") : "",
      icms_origem: form.icms_origem || "",
      pis_situacao_tributaria: form.pis_situacao_tributaria || "",
      cofins_situacao_tributaria: form.cofins_situacao_tributaria || "",
      ipi_situacao_tributaria: form.ipi_situacao_tributaria || "",
      cest: form.cest || "",
      nomeSearch: normalizeText(form.nome),
    };

    try {
      if (form.sku) {
        const qSku = query(colProdutos(db, empresaId), where("sku", "==", form.sku));
        const snapSku = await getDocs(qSku);
        const duplicado = snapSku.docs.find(d => !editando || d.id !== produtoId);
        if (duplicado) {
            setErrors(prev => ({ ...prev, sku: "Já existe um produto com este código/SKU." }));
            Swal.fire({ icon: "error", title: "SKU já cadastrado", text: "Já existe um produto com esse código/SKU." });
            return;
        }
      }

      if (editando && produtoId) {
        await updateDoc(refProduto(db, empresaId, produtoId), { ...dados });
        onImportar && onImportar();
        Swal.fire({ icon: "success", title: "Produto atualizado!", showConfirmButton: false, timer: 1500 });
        onClose();
      } else {
        await addDoc(colProdutos(db, empresaId), { ...dados, criadoEm: Timestamp.now() });
        onImportar && onImportar();
        Swal.fire({ icon: "success", title: "Produto criado!", showConfirmButton: false, timer: 1500 });
        onClose();
      }
    } catch (err) {
      setErrors(prev => ({ ...prev, submit: "Erro ao salvar" }));
      Swal.fire({ icon: "error", title: "Erro ao salvar", text: err?.message || "" });
      console.error(err);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[2px] animate-fadein">
      <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl w-full max-w-3xl max-h-[94vh] flex flex-col overflow-hidden animate-modalSlideIn">
        <div className="px-8 pt-7 pb-4 border-b border-gray-100 dark:border-gray-800 relative">
          <button className="absolute right-8 top-7 text-gray-500 hover:text-[#004072] dark:text-gray-200" onClick={onClose}>
            Fechar
          </button>
          <h2 className="text-2xl font-bold text-blue-600 dark:text-white">
            {editando ? "Editar Produto" : "Novo Produto"}
          </h2>
        </div>

        <form className="flex-1 overflow-y-auto px-8 py-6 space-y-6" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          
          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Código/SKU</label>
              <InputIcon
                icon={<FaBarcode />} placeholder="Ex: 789..." value={form.sku}
                onChange={e => onChange("sku", e.target.value)} onBlur={handleBuscaSku}
                className="border rounded-xl px-4 py-3 w-full focus:ring-2 focus:ring-[#004AAD] transition bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                autoFocus disabled={editando}
              />
              {errors.sku && <span className="text-red-500 text-xs">{errors.sku}</span>}
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">NCM</label>
              <InputIcon icon={<FaBarcode />} placeholder="Ex: 8539..." value={form.ncm} onChange={e => onChange("ncm", e.target.value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
              {errors.ncm && <span className="text-red-500 text-xs">{errors.ncm}</span>}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Nome</label>
              <InputIcon icon={<FaTag />} placeholder="Ex: Filtro..." value={form.nome} onChange={e => onChange("nome", e.target.value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
              {errors.nome && <span className="text-red-500 text-xs">{errors.nome}</span>}
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Descrição</label>
              <InputIcon icon={<FaStickyNote />} placeholder="Opcional" value={form.descricao} onChange={e => onChange("descricao", e.target.value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Preço bruto (R$)</label>
              <InputIcon icon={<FaDollarSign />} mask="num" blocks={{ num: { mask: Number, thousandsSeparator: '.', radix: ',', scale: 2, padFractionalZeros: true } }} placeholder="Ex: 25,00" value={form.precoBruto} onAccept={value => onChange("precoBruto", value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
              {errors.precoBruto && <span className="text-red-500 text-xs">{errors.precoBruto}</span>}
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">% Lucro</label>
              <InputIcon icon={<FaPercent />} mask="num" blocks={{ num: { mask: Number, scale: 2, max: 999, padFractionalZeros: true, radix: ',' } }} placeholder="Ex: 60" value={form.porcentagemLucro} onAccept={value => onChange("porcentagemLucro", value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">{editando ? "Estoque novo" : "Estoque inicial"}</label>
              <InputIcon icon={<FaCubes />} mask="num" blocks={{ num: { mask: Number, min: 0, thousandsSeparator: '.' } }} placeholder="Ex: 10" value={form.estoque} onAccept={value => onChange("estoque", value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
              {errors.estoque && <span className="text-red-500 text-xs">{errors.estoque}</span>}
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Unidade</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaBalanceScale /></span>
                <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.unidade || "UN"} onChange={e => onChange("unidade", e.target.value)}>
                  {unidades.map(u => (<option key={u} value={u}>{u}</option>))}
                </select>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mt-2">
            <button type="button" onClick={() => setDetalhesFiscais(v => !v)} className="flex items-center gap-2 text-blue-600 dark:text-blue-300 font-semibold transition hover:underline">
              {detalhesFiscais ? <FaChevronUp /> : <FaChevronDown />} {detalhesFiscais ? "Ocultar detalhes fiscais" : "Mostrar detalhes fiscais"}
            </button>
          </div>

          {detalhesFiscais && (
            <>
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold mb-1 dark:text-gray-200">CFOP</label>
                  <InputIcon icon={<FaExchangeAlt />} placeholder="Ex: 5102" value={form.cfop} onChange={e => onChange("cfop", e.target.value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
                  {errors.cfop && <span className="text-red-500 text-xs">{errors.cfop}</span>}
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Origem ICMS</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaFileInvoiceDollar /></span>
                    <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.icms_origem || ""} onChange={e => onChange("icms_origem", e.target.value)}>
                      <option value="">Selecione</option>
                      {ICMS_ORIGEM_OPTIONS.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                    </select>
                  </div>
                  {errors.icms_origem && <span className="text-red-500 text-xs">{errors.icms_origem}</span>}
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-5">
                {(regimeTributario === "1" || regimeTributario === "4") ? (
                    <div>
                        <label className="block text-sm font-semibold mb-1 dark:text-gray-200">CSOSN</label>
                        <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaListOl /></span>
                        <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.csosn || ""} onChange={e => onChange("csosn", e.target.value)}>
                            <option value="">Selecione</option>
                            {CSOSN_OPTIONS.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                        </select>
                        </div>
                        {errors.csosn && <span className="text-red-500 text-xs">{errors.csosn}</span>}
                    </div>
                ) : (
                    <div>
                        <label className="block text-sm font-semibold mb-1 dark:text-gray-200">CST</label>
                        <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaListOl /></span>
                        <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.cst || ""} onChange={e => onChange("cst", e.target.value)}>
                            <option value="">Selecione</option>
                            {CST_OPTIONS.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                        </select>
                        </div>
                        {errors.cst && <span className="text-red-500 text-xs">{errors.cst}</span>}
                    </div>
                )}
                 <div>
                    <label className="block text-sm font-semibold mb-1 dark:text-gray-200">CEST</label>
                    <InputIcon icon={<FaGavel />} placeholder="Opcional" value={form.cest} onChange={e => onChange("cest", e.target.value)} className="border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" />
                </div>
              </div>

               <div className="grid md:grid-cols-2 gap-5">
                <div>
                   <label className="block text-sm font-semibold mb-1 dark:text-gray-200">PIS</label>
                    <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaFileInvoiceDollar /></span>
                        <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.pis_situacao_tributaria || ""} onChange={e => onChange("pis_situacao_tributaria", e.target.value)}>
                            <option value="">Selecione</option>
                            {SITUACAO_TRIBUTARIA_OPTIONS.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                        </select>
                    </div>
                    {errors.pis_situacao_tributaria && <span className="text-red-500 text-xs">{errors.pis_situacao_tributaria}</span>}
                </div>
                <div>
                   <label className="block text-sm font-semibold mb-1 dark:text-gray-200">COFINS</label>
                    <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaFileInvoiceDollar /></span>
                        <select className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.cofins_situacao_tributaria || ""} onChange={e => onChange("cofins_situacao_tributaria", e.target.value)}>
                            <option value="">Selecione</option>
                            {SITUACAO_TRIBUTARIA_OPTIONS.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                        </select>
                    </div>
                    {errors.cofins_situacao_tributaria && <span className="text-red-500 text-xs">{errors.cofins_situacao_tributaria}</span>}
                </div>
               </div>
               
               <div>
                <label className="block text-sm font-semibold mb-1 dark:text-gray-200">IPI</label>
                <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><FaFileInvoiceDollar /></span>
                    <input type="text" placeholder="Ex: 53" className="pl-10 border rounded-xl px-4 py-3 w-full bg-gray-50 dark:bg-gray-800 dark:text-white" value={form.ipi_situacao_tributaria || ""} onChange={e => onChange("ipi_situacao_tributaria", e.target.value)} />
                </div>
                {errors.ipi_situacao_tributaria && <span className="text-red-500 text-xs">{errors.ipi_situacao_tributaria}</span>}
               </div>
            </>
          )}

          <div>
            <label className="block text-sm font-semibold mb-1 dark:text-gray-200">Preço de venda (calculado)</label>
            <input type="text" className="border rounded-xl px-4 py-3 w-full bg-gray-100 dark:bg-gray-800 dark:text-green-400 text-green-700 font-bold" value={precoVenda ? `R$ ${precoVenda}` : ""} disabled />
          </div>

          {errors.submit && <span className="text-red-500 text-xs">{errors.submit}</span>}
        </form>

        <div className="px-8 pb-6 pt-4 border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900">
          <button type="button" onClick={handleSave} className="w-full py-3 rounded-xl bg-blue-600 text-white text-lg font-semibold flex items-center justify-center gap-2 shadow-lg hover:bg-[#005288] transition">
            {editando ? <FaSave /> : <FaPlusCircle />} {editando ? "Salvar Alterações" : "Cadastrar Produto"}
          </button>
        </div>
      </div>
      <style>{`.animate-modalSlideIn { animation: modalSlideIn 0.35s cubic-bezier(.32,.72,.57,1) both; } @keyframes modalSlideIn { 0% { opacity:0; transform: translateY(60px) scale(.97);} 100% { opacity:1; transform: translateY(0) scale(1);} } .animate-fadein { animation: fadein 0.25s; } @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }`}</style>
    </div>
  );
};

export default ModalNovoProduto;